import { useEffect, useRef } from "react";
import { CharacterMode, CharacterPose, CharacterOutfit, CharacterHair, drawCharacter } from "./rooftopRenderer";
import { CityPhase, drawCity } from "./cityRenderer";

export default function CityScene({ phase, selected, hour, paused, characterMode = "normal", characterPose = "default", characterOutfit = "long", characterHair = "layered" }: { phase: CityPhase; selected: number; hour: number; paused: boolean; characterMode?: CharacterMode; characterPose?: CharacterPose; characterOutfit?: CharacterOutfit; characterHair?: CharacterHair }) {
  const canvas = useRef<HTMLCanvasElement>(null);
  const elapsed = useRef(0);
  useEffect(() => {
    const context = canvas.current?.getContext("2d", { alpha: false });
    if (!context) return;
    context.imageSmoothingEnabled = false;
    let frame = 0, last = 0, previousPaint = 0;
    const sprite = new Image();
    const overlay = new Image();
    const paint = () => {
      drawCity(context, phase, selected, hour, elapsed.current);
      drawCharacter(context,sprite,phase,elapsed.current,characterMode,characterPose,characterOutfit,undefined,overlay);
    };
    sprite.onload=paint;
    overlay.onload=paint;
    const lighting = hour < 6 || hour >= 19 ? 'night' : hour < 12 ? 'morning' : 'afternoon';
    overlay.src='/images/character-lighting/' + lighting + '.png?v=1';
    const variant = characterHair + '-' + (characterMode === "coffee" ? "coffee" : "normal");
    sprite.src='/images/rooftop-v12-' + variant + '.png?v=phone-coffee-hand-1';
    const tick = (now: number) => {
      if (last) elapsed.current += Math.min((now - last) / 1000, .1);
      last = now;
      if (now - previousPaint >= 1000 / 24) { paint(); previousPaint = now; }
      frame = requestAnimationFrame(tick);
    };
    const sync = () => {
      cancelAnimationFrame(frame); last = 0;
      paint();
      if (!paused && !document.hidden) frame = requestAnimationFrame(tick);
    };
    sync();
    document.addEventListener("visibilitychange", sync);
    return () => { sprite.onload=null; overlay.onload=null; cancelAnimationFrame(frame); document.removeEventListener("visibilitychange", sync); };
  }, [phase, selected, hour, paused, characterMode, characterPose, characterOutfit, characterHair]);
  return <canvas ref={canvas} className="city-canvas" width="480" height="300" aria-hidden="true" />;
}
